import React from 'react';
import Link from 'next/link';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

type DynamicComponentProps = {
  zuiComponent: 'LinkV2' | 'ButtonV3';
  children: React.ReactNode;
};

const DynamicComponent: React.ForwardRefExoticComponent<DynamicComponentProps> = React.forwardRef<
  HTMLAnchorElement & HTMLButtonElement,
  DynamicComponentProps
>(({ zuiComponent, children, ...props }, ref) => {
  const Component = zuiComponent === 'LinkV2' ? LinkV2 : ButtonV3;
  return (
    <Component innerRef={ref as React.RefObject<HTMLButtonElement>} {...props}>
      {children}
    </Component>
  );
});

type RouterLinkProps = {
  href: string;
  zuiComponent: 'LinkV2' | 'ButtonV3';
  children: React.ReactNode;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  [unknownProp: string]: any; // any zola-ui props related to Link or ButtonV2
};

const RouterLink = ({
  href,
  zuiComponent = 'LinkV2',
  children,
  ...props
}: RouterLinkProps): JSX.Element => (
  <Link href={href} passHref>
    <DynamicComponent zuiComponent={zuiComponent} {...props}>
      {children}
    </DynamicComponent>
  </Link>
);

export default RouterLink;
